import React, { useState } from 'react'
import Container from 'components/Container'
// import { Link as HistoryLink } from 'react-router-dom'
import { RowBetween } from 'components/Row'
import { ColumnCenter } from 'components/Column'
import { useMemeList } from 'data/MemeList'
import { AddressZero } from '@ethersproject/constants'
import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next'
import useToast from 'hooks/useToast'
import { useActiveWeb3React } from '../../hooks'
import AppBody from '../AppBody'
import { Wrapper, Name, Desc, CopyIcon, NoMore } from './styleds'
import copyImg from '../../assets/images/copy.png'

export default function MemeList() {
   const { account } = useActiveWeb3React()
   const { toastSuccess } = useToast()
   const  { tokenList } = useMemeList(account ?? AddressZero)

   const { t } = useTranslation()
   
   const handleCopy = (address) => {
      copy(address)
      toastSuccess(t('copy successfully'))
    }
  return (
  <Container>
   <ColumnCenter style={{ minHeight: '63vh', width: "100%" }}>
     { tokenList.length > 0 ? (tokenList.map((item:any) => (
  <AppBody key={ item.tokenAddress }>
    <Wrapper>
       <RowBetween marginBottom='20px'>
         <div>
            <Name>{ item.symbol }</Name>
            <Desc>{ t('Symbol') }</Desc>
         </div>
         <div>
            <Name>{ item.amount }</Name>
            <Desc>{ t('Token amount') }</Desc>
         </div>
         <div>
            <Name className='active'>{ t('Success') }</Name>
            <Desc>{ t('Status') }</Desc>
         </div>
       </RowBetween>
       <Name style={{ textAlign: 'left' }}>{ t('Contract address') }</Name>
       <RowBetween>
         <Desc className='address'>{ item.tokenAddress }</Desc>
         <CopyIcon src={ copyImg } size='15px' onClick={(event) => {
                      event.stopPropagation()
                       handleCopy(item.tokenAddress)
                    }}/>
       </RowBetween>
       {/* <RowBetween style={{ marginTop: '1rem' }}>
         <HistoryLink to={ `/register/${item.lockAdderss}` }>
             <Button width="100%">{ t('Contract Registration') }</Button>
         </HistoryLink>
        <HistoryLink to={ `/airdrop/${item.lockAdderss}` }>
             <Button width="100%">{ t('Airdrop') }</Button>
         </HistoryLink>
       </RowBetween> */}
    </Wrapper>
  </AppBody>))) : <NoMore>{ t('No records') }</NoMore>}
   </ColumnCenter>
 </Container>
)}